<template>
	<div class="grid sm:flex justify-between gap-4 items-stretch">
		<lineup :players="lineup" @selected="onSelected" :active-player="activePlayer"></lineup>

		<!-- Banca -->
		<section class="bg-white fixed z-10 lg:relative transition-all inset-x-0 rounded-t-lg border-2 border-black grow pt-12"
		:class="activePlayer ? 'bottom-0' : '-bottom-full'">	
			<div class="flex justify-between py-2 border-b px-4 gap-4 absolute inset-x-0 z-30 top-0">
				<h2 class="text-lg font-bold"> Banca </h2>	
				<input type="text" class="border-2 border-black rounded-lg px-2 py-1 text-xs" placeholder="Buscar jugador" v-model="query">
				<button class="underline lg:hidden" @click="activePlayer = null"> Cerrar </button>
			</div>
			<div class="overflow-y-scroll lg:overflow-y-auto h-64 lg:h-full">	
		<div v-for="(players, position) in groupedPlayers" :key="position" class="px-2 relative" v-if="query.length == 0">
			<h3 class="text-xs font-semibold text-gray-500 px-2 text-center">{{ position }}</h3>
			<ul class="grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-8 divide-x divide-y">
				<li class="text-center py-2 px-1 relative transition-opacity hover:opacity-100" v-for="player in players" :key="player.id"
				@click="swapPlayer(player)"
				:class="{ 'opacity-100': activePlayer && activePlayer.position === player.position, 
							 'opacity-50': activePlayer && activePlayer.position !== player.position,
							'opacity-25': lineup.find((p: Player) => p.id === player.id) }">	
					<div v-if="lineup.find((p: Player) => p.id === player.id)" class="absolute top-0 bg-green-500 text-white text-xs px-2 rounded-b-lg left-2">T</div>	
					<div v-if="activePlayer && activePlayer.id === player.id" class="absolute top-0 bg-green-500 text-white text-xs px-2 rounded-b-lg left-2">A</div>
					<img :src="player.image" alt="" class="h-12 w-12 mx-auto object-cover rounded-full">
					<div class="bg-rose-800 text-white text-xs px-2 rounded-se-lg rounded-es-lg mx-auto absolute left-2 bottom-7">{{ player.number }}</div>
					<div class="text-xs mt-0.5">{{ player.nickname }}</div>
					<div class="text-xs font-light text-gray-500 absolute bottom-0">{{ player.country }}</div>
				</li>
			</ul>
		</div>
		<ul class="grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-8 divide-x divide-y" v-else>
				<li class="text-center py-2 px-1 relative transition-opacity  hover:opacity-100" v-for="player in filteredPlayers" :key="player.id"
				@click="swapPlayer(player)"
				:class="{ 'opacity-100': activePlayer && activePlayer.position === player.position, 'opacity-50': activePlayer && activePlayer.position !== player.position }">	
					<div v-if="lineup.find((p: Player) => p.id === player.id)" class="absolute top-0 bg-green-500 text-white text-xs px-2 rounded-b-lg left-2">T</div>	
					<div v-if="activePlayer && activePlayer.id === player.id" class="absolute top-0 bg-green-500 text-white text-xs px-2 rounded-b-lg left-2">A</div>
					<img :src="player.image" alt="" class="h-12 w-12 mx-auto object-cover rounded-full">
					<div class="bg-rose-800 text-white text-xs px-2 rounded-se-lg rounded-es-lg mx-auto absolute left-2 bottom-7">{{ player.number }}</div>
					<div class="text-xs mt-0.5">{{ player.nickname }}</div>
					<div class="text-xs font-light text-gray-500 absolute bottom-0">{{ player.country }}</div>
				</li>
			</ul>
			</div>
		</section>

		<section>
			Compartir
		</section>
		<section>	
			// share screen
			Copiar enlace
			<code>https://www.futbol5.com/lineup/{{ id }}</code>
			<button> Copiar </button>
			Whatsapp
			Twitter
			// crear foto
			Donwload foto
		</section>
		<section>
			Shared with you
		</section>
	</div>
</template>
<script lang="ts">

import { Player } from '../types';
import Lineup from './lineup.vue';

export default {
	components: {
	 Lineup,
  },
  props: {
    players: {
      type: Array as () => Player[],
      required: true,
    },
  },
  data() {
    return {
		query: "",
		name: "El Tri-5-2",
		id: "ABC123",
		byline: "@freezy",
		votes: 10,
		shuffles: 2456,
		lineup: [],
		groupedPlayers: [],
		activePlayer: null,
    };
  },
  computed: {
	filteredPlayers(): Player[] {
		return this.players.filter((player: Player) => player.name.toLowerCase().includes(this.query.toLowerCase()));
	},
  },
  mounted() {
	// group players by position
	this.groupedPlayers = this.players.reduce((acc, player) => {
		if (!acc[player.position]) {
			acc[player.position] = [];
		}
		acc[player.position].push(player);
		return acc;
	}, {});

	// GK
	this.lineup.push(
		this.groupedPlayers["Arquero"].find((p: Player) => p.number === 1),
	)
	this.lineup[0].x = 50
	this.lineup[0].y = 10

	// defensa
	this.lineup.push(
		this.groupedPlayers["Defensa"].find((p: Player) => p.number === 3),
		this.groupedPlayers["Defensa"].find((p: Player) => p.number === 29),
		this.groupedPlayers["Defensa"].find((p: Player) => p.number === 5),
	)

	this.lineup[1].x = 50
	this.lineup[1].y = 25

	this.lineup[2].x = 20
	this.lineup[2].y = 30

	this.lineup[3].x = 80
	this.lineup[3].y = 30

	// mediocampista

	this.lineup.push(
		this.groupedPlayers["Carrilero"].find((p: Player) => p.number === 24),
		this.groupedPlayers["Carrilero"].find((p: Player) => p.number === 34),
	)

	this.lineup[4].x = 10
	this.lineup[4].y = 55

	this.lineup[5].x = 90
	this.lineup[5].y = 55


	this.lineup.push(
		this.groupedPlayers["Mediocampista"].find((p: Player) => p.number === 18),
		this.groupedPlayers["Mediocampista"].find((p: Player) => p.number === 16),
		this.groupedPlayers["Mediocampista"].find((p: Player) => p.number === 10),
	)

	this.lineup[6].x = 50
	this.lineup[6].y = 50

	this.lineup[7].x = 30
	this.lineup[7].y = 60

	this.lineup[8].x = 70
	this.lineup[8].y = 60

	// delantero
	this.lineup.push(
		this.groupedPlayers["Delantero"].find((p: Player) => p.number === 19),
		this.groupedPlayers["Delantero"].find((p: Player) => p.number === 20),
	)

	this.lineup[9].x = 35
	this.lineup[9].y = 78

	this.lineup[10].x = 65
	this.lineup[10].y = 78

	// remove lineup players from groupedPlayers
	this.lineup.forEach((player: Player) => {
		const index = this.groupedPlayers[player.position].findIndex((p: Player) => p.id === player.id);
		this.groupedPlayers[player.position].splice(index, 1);
	});
  },
  methods: {
	onSelected(player: Player) {
		// if (this.activePlayer) {
		// 	this.activePlayer = null;
		// 	return;
		// }
		this.activePlayer = player;
	},
	swapPlayer(player: Player) {
		if (!this.activePlayer) {
			return;
		}
		const index = this.lineup.findIndex((p: Player) => p.id === this.activePlayer.id);
		this.lineup.splice(index, 1, player);

		// update player position
		this.lineup[index].x = this.activePlayer.x;
		this.lineup[index].y = this.activePlayer.y;

		// add oldPlayer to groupedPlayers
		this.groupedPlayers[this.activePlayer.position].push(this.activePlayer);

		// remove player from groupedPlayers
		const playerIndex = this.groupedPlayers[player.position].findIndex((p: Player) => p.id === player.id);
		this.groupedPlayers[player.position].splice(playerIndex, 1);

		this.activePlayer = null;
  },
  }
};
</script>


<style scoped></style>
